import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import IconFA from '../icon/icon';
import './sidebar.css'

function Sidebar() {
    const [isExpanded, setIsExpanded] = useState(false);
    const sidebarRef = useRef(null);
    
    // Schließe Sidebar beim Klick außerhalb
    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsExpanded(false);
            }
        }
        
        if (isExpanded) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [isExpanded]);
    
    return (
        <div 
            ref={sidebarRef}
            className={`sidebar ${isExpanded ? 'sidebar--expanded' : ''}`}
            onClick={() => setIsExpanded(!isExpanded)}
        >
            <p className="sidebarMenuItem">
                <IconFA iconName="table" color="white" fontSize="20px" />
                <Link to='/dashboard'>Übersicht</Link>
            </p>
            <p className="sidebarMenuItem">
                <IconFA iconName="userGroup" color="white" fontSize="20px" />
                <Link to='/dashboard/customer'>Kunden</Link>
            </p>
            <p className="sidebarMenuItem">
                <IconFA iconName="fileLines" color="white" fontSize="20px" />
                <Link to='/dashboard/invoice'>Rechnungen</Link>
            </p>
            <p className="sidebarMenuItem">
                <IconFA iconName="calendarCheck" color="white" fontSize="20px" />
                <Link to='/dashboard/appointments'>Termine</Link>
            </p>
            <p className="sidebarMenuItem">
                <IconFA iconName="listCheck" color="white" fontSize="20px" />
                <Link to='/dashboard/todos'>Todos</Link>
            </p>
            {/* <p className="sidebarMenuItem">
                <IconFA iconName="sitemap" color="white" fontSize="20px" />
                <Link to='/dashboard/events'>Events</Link>
            </p> */}
            <p className="sidebarMenuItem">
                <IconFA iconName="book" color="white" fontSize="20px" />
                <Link to='/dashboard/accounting'>Buchhaltung</Link>
            </p>
            <p className="sidebarMenuItem">
                <IconFA iconName="user" color="white" fontSize="20px" />
                <Link to='/dashboard/settings'>Profil</Link>
            </p>
        </div>
    );
}

export default Sidebar;